import { Action, ThunkAction } from "@reduxjs/toolkit"
import { StoreState } from "../store/StoreState"
import { settingsActions, settingsSelectors } from "@/slices/settingsSlice"
import { callApi, callAuthedApi } from "@/services/serverService"

export const ensureSettingsThunk =
  (force?: boolean): ThunkAction<void, StoreState, null, Action> =>
  async (dispatch, getState) => {
    if (!force && settingsSelectors.settings(getState())) {
      return
    }
    const settings = await callApi<ISettingsDto>("settings", "get")
    dispatch(settingsActions.setSettings(settings))
  }

export const updateSettingsThunk =
  (settings: ISettingsDto): ThunkAction<void, StoreState, null, Action> =>
  async (dispatch, getState) => {
    await callAuthedApi<ISettingsDto>("settings", "post", settings)
    await dispatch(ensureSettingsThunk(true))
  }
